import { motion } from "framer-motion";
import { useLang } from "../../i18n/LanguageContext";

const item = {
  hidden: { opacity: 0, y: 20 },
  show: (i) => ({ opacity: 1, y: 0, transition: { duration: 0.5, delay: i * 0.05 } }),
};

export const LandLeasing = () => {
  const { t } = useLang();
  const L = t.land;
  return (
    <section id="land" className="relative py-24 sm:py-32 bg-[var(--ink)] text-[var(--page)] overflow-hidden" data-testid="land-section">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
        <div className="max-w-2xl">
          <div className="flex items-center gap-3 mb-6">
            <span className="h-px w-10 bg-[var(--page)]/60" />
            <span className="text-[11px] sm:text-xs uppercase tracking-[0.25em] text-[var(--page)]/60 font-semibold">{L.overline}</span>
          </div>
          <h2 className="font-display font-semibold tracking-tight leading-[1.03] text-3xl sm:text-4xl lg:text-5xl">{L.title}</h2>
          <p className="mt-6 text-base sm:text-lg text-[var(--page)]/70 leading-relaxed">{L.sub}</p>
        </div>

        <div className="mt-14 grid lg:grid-cols-2 gap-12 lg:gap-16">
          <div>
            <h3 className="text-xs uppercase tracking-[0.2em] text-[var(--page)]/50 font-semibold mb-6">{L.typesHeading}</h3>
            <div className="border-t border-[var(--page)]/15">
              {L.types.map((it, i) => (
                <motion.div
                  key={i} custom={i} initial="hidden" whileInView="show" viewport={{ once: true, margin: "-40px" }} variants={item}
                  data-testid={`land-type-${i}`}
                  className="py-5 border-b border-[var(--page)]/15"
                >
                  <h4 className="font-display text-lg sm:text-xl leading-tight">{it.t}</h4>
                  <p className="mt-2 text-sm sm:text-base text-[var(--page)]/70 leading-relaxed">{it.d}</p>
                </motion.div>
              ))}
            </div>
          </div>

          <div>
            <h3 className="text-xs uppercase tracking-[0.2em] text-[var(--page)]/50 font-semibold mb-6">{L.stepsHeading}</h3>
            <div className="border-t border-[var(--page)]/15">
              {L.steps.map((it, i) => (
                <motion.div
                  key={i} custom={i} initial="hidden" whileInView="show" viewport={{ once: true, margin: "-40px" }} variants={item}
                  data-testid={`land-step-${i}`}
                  className="flex gap-5 py-5 border-b border-[var(--page)]/15"
                >
                  <span className="font-display text-[var(--page)]/40 text-2xl leading-none shrink-0">{String(i + 1).padStart(2, "0")}</span>
                  <div>
                    <h4 className="font-display text-lg sm:text-xl leading-tight">{it.t}</h4>
                    <p className="mt-2 text-sm sm:text-base text-[var(--page)]/70 leading-relaxed">{it.d}</p>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
